// TODO: Move to `@adc/blueprint` since it's a product requirement and is all a bit magic and dangly being like this
export default similarProperties => similarProperties.length > 3
